import fp from 'lodash/fp'
import styled from '@emotion/styled'
import { colors, font } from 'styles/variables'
import { TABLETS, PHONES } from 'styles/media-queries'

const TextComponent = styled.span`
  font-family: ${font.family};

  ${({ alignRight }) => alignRight && 'text-align: right;'}
  ${({ underline }) => underline && 'text-decoration: underline;'}

  ${({ block }) => block && 'display: block;'}
  ${({ inline }) => inline && 'display: inline-block;'}

  ${({ green }) => green && `color: ${colors.greens.green1};`}
  ${({ gray }) => gray && `color: ${colors.grays.gray1};`}
  ${({ white }) => white && `color: ${colors.white100};`}
  ${({ black }) => black && `color: ${colors.black100};`}
  ${({ red }) => red && `color: ${colors.red.red5};`}
  ${({ upper }) => upper && 'text-transform: uppercase;'}
  ${({ lower }) => lower && 'text-transform: lowercase;'}

  ${({ size, unit }) => `font-size: ${size + unit};`}
  ${({ italic }) => italic && 'font-style: italic;'}
 
  ${({ maxCh }) => maxCh && `max-width: ${maxCh}ch;`};
  ${({ nowrap }) => nowrap && 'white-space: nowrap;'}
  ${({ ellipsis }) => ellipsis && 'text-overflow: ellipsis; overflow: hidden;'}

  ${({ tabletSize, unit }) =>
    tabletSize && `${TABLETS} { font-size: ${tabletSize + unit}; }`}

  ${({ phoneSize, unit }) =>
    phoneSize && `${PHONES} { font-size: ${phoneSize + unit}; }`}

  ${({ weight, bold }) => {
    let weightValue = 100

    if (bold) {
      weightValue = 600
    }

    if (fp.isNumber(weight)) {
      weightValue = weight
    }

    return `font-weight: ${weightValue};`
  }};
`

TextComponent.defaultProps = {
  size: 16,
  unit: 'px',
  white: true,
}

export default TextComponent
